import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  background: rgb(255, 255, 255);
  padding: 15px;
  width: 100%;
  border-radius: 5px;
`
